import React, { Component } from "react"
import PropTypes from "prop-types"
import Message from "../Message"
import Modal from "../Modal"

class MessageModal extends Component {
  render() {
    let {
      isOpen,
      close,
      title,
      message,
      type,
      callToAction,
      children,
    } = this.props
    return (
      <Modal isOpen={isOpen} close={close}>
        <Message
          title={title}
          message={message}
          type={type}
          isModal={true}
          callToAction={{
            route: callToAction.route,
            buttonText: callToAction.buttonText,
            closeModal: close,
          }}
        >
          {children}
        </Message>
      </Modal>
    )
  }
}

MessageModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
  title: PropTypes.string,
  message: PropTypes.string,
  type: PropTypes.string,
  callToAction: PropTypes.shape({
    route: PropTypes.string,
    buttonText: PropTypes.string,
    closeModal: PropTypes.func,
  }),
}

export default MessageModal
